import React from 'react';
import {
  Plus, Search, Bell, Home, Layers, File, Folder, Settings, Users,
  ArrowRight, ArrowLeft, ChevronRight, Download, Upload, Check, Clock,
  Lock, Send, Calendar, Coins, TrendingUp, MoreHorizontal, Zap, Target,
  Mail, UserPlus, X, Pencil, Play, Book, Shield, SlidersHorizontal,
} from 'lucide-react';

// Keys mirror the design mockups' Icon names so screen JSX ports verbatim.
const ICONS = {
  plus: Plus, search: Search, bell: Bell, home: Home, layers: Layers,
  file: File, folder: Folder, settings: Settings, users: Users,
  arrowRight: ArrowRight, arrowLeft: ArrowLeft, chevronRight: ChevronRight,
  download: Download, upload: Upload, check: Check, clock: Clock,
  lock: Lock, send: Send, calendar: Calendar, coins: Coins,
  trendUp: TrendingUp, dots: MoreHorizontal, bolt: Zap, target: Target,
  mail: Mail, userPlus: UserPlus, x: X, edit: Pencil, play: Play,
  book: Book, shield: Shield, sliders: SlidersHorizontal,
};

export const ICON_NAMES = Object.keys(ICONS);

export default function Icon({ name, size = 18, stroke = 2, fill = false, style, ...rest }) {
  const Cmp = ICONS[name];
  if (!Cmp) return null;
  return (
    <Cmp
      size={size}
      strokeWidth={stroke}
      fill={fill ? 'currentColor' : 'none'}
      style={style}
      aria-hidden="true"
      {...rest}
    />
  );
}
